import { createFileRoute } from "@tanstack/react-router";
import { SetupPassword } from "@/features/auth/components/SetupPassword";

export const Route = createFileRoute("/_auth/setup-password")({
  validateSearch: (search) => {
    return {
      token: search.token || "",
    };
  },
  component: SetupPassword,
});
